import { useContext, useEffect, useRef, useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { ImPointUp } from 'react-icons/im';
import { Context } from '../function/Contact';
import axiosInterceptor from '../function/axiosInterceptor';
import './css/main.css';
import './css/animate.css';
import { toast } from 'react-toastify';
function Header() {
  const close = useRef(null)
  const [act, setAct] = useState({ OTPloader: false, verfyLoader: false, step: 0 })
  const [data, setData] = useState({ userId: '' })
  const { info, menu, socialIcon } = useContext(Context)
  const manageToggle = () => {
    document.querySelector(".navbar-collapse").className = "navbar-collapse collapse show";
  }
  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInterceptor.post('/subscriber', data);
      if (response.status === 1) {
        setData((prev) => ({ ...prev, email: '' }))
        toast.success(response.message, { autoClose: 700, position: 'top-center' })
      } else {
        toast.warn(response.message, { autoClose: 700, position: 'top-center' })
      }
    } catch (err) { }
  }
  const sendOTP = async (e) => {
    e.preventDefault();
    try {
      setAct(prev => ({ ...prev, OTPloader: true, step: 0 }))
      const response = await axiosInterceptor.post('/volunteerlogin', data);
      if (response.status === 1) {
        setData((prev) => ({ ...prev, otp: '' }))
        setAct(prev => ({ ...prev, step: 1 }))
        toast.success(response.message, { autoClose: 700, position: 'top-center' })
      } else {
        toast.warn(response.message, { autoClose: 700, position: 'top-center' })
      }
    } catch (err) { } finally {
      setAct(prev => ({ ...prev, OTPloader: false }))
    }
  }
  const verifyOTP = async (e) => {
    e.preventDefault();
    try {
      setAct(prev => ({ ...prev, verifyOTP: true }))
      const response = await axiosInterceptor.post('/volunteerloginverification', data);
      if (response.status != 1) {
        toast.warn(response.message, { autoClose: 700, position: 'top-center' }); return
      }
      setData((prev) => ({ ...prev, userId: '', otp: '' }))
      setAct(prev => ({ ...prev, step: 0 }))
      close.current.click()
      toast.success(response.message, { autoClose: 700, position: 'top-center' })
      localStorage.setItem('mnbfutoken', response.token)
    } catch (err) { } finally {
      setAct(prev => ({ ...prev, verifyOTP: false }))
    }
  }
  useEffect(()=>{ setData((prev) => ({ ...prev, userId: '', otp: '' })) },[])
  return (<>
    <header>
      <div className="body-overlay" id="body-overlay"></div>
      <div className="search-popup" id="search-popup">
        <form action="" className="search-form">
          <div className="form-group">
            <input type="text" className="form-control" placeholder="Search....." />
          </div>
          <button className="close-btn border-none"><i className="fas fa-times"></i></button>
        </form>
      </div>
      <div className="header-style-01">
        <div className="topbar-area">
          <div className="container-">
            <div className="row">
              <div className="col-lg-12">
                <div className="topbar-inner">
                  <div className="left-contnet">
                    <ul className="info-items">
                      <li><Link to={"tel:" + info?.phone}><i className="fa fa-phone" style={{ transform: "rotate(90deg)" }}></i>{info?.phone}</Link></li>
                      <li>
                        <Link to={"mailto: " + info?.email} >
                          <i className="far fa-envelope-open"></i><span className="__cf_email__" data-cfemail="254c4b434a65405d44485549400b464a48">
                            {info?.email}
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="right-contnet">
                    <div className="social-link">
                      <ul>
                        <li><Link to="https://www.facebook.com/mnbfoundations" target='_blank'><div className="Container" ><i class="fab fa-facebook"></i></div></Link></li>
                        <li><Link to="https://www.instagram.com/mnbfoundation/" target='_blank'><div className="Container" ><i class="fab fa-instagram"></i></div></Link></li>
                        <li><Link to="https://www.youtube.com/@MnbFoundation/" target='_blank'><div className="Container" ><i class="fab fa-youtube"></i></div></Link></li>
                        <li><Link to="https://www.linkedin.com/company/104817046/admin/dashboard/" target='_blank'><div className="Container" ><i class="fab fa-linkedin-in"></i></div></Link></li>

                        {
                          socialIcon.map((icon) => {
                            if (icon.status === 1) {
                              return (<>
                                <li><Link to={icon.url}><div className="Container" dangerouslySetInnerHTML={{ __html: icon.name }}></div></Link></li>
                              </>)
                            }
                          })
                        }
                      </ul>
                    </div>
                    <div className="volunteer-right">
                      <ul className="info-items-02">
                        <li className="volunteer"><Link to=""><i><ImPointUp /></i>Want to work with us ?</Link></li>
                        <li className="volunteer"><NavLink to="volunteer">Become a Volunteer</NavLink></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-area navbar-expand-lg has-topbar nav-style-02">
          <div className="container-fluid nav-container">
            <div className="responsive-mobile-menu">
              <div className="logo-wrapper">
                <Link to="/" className="logo">
                  <img src={process.env.REACT_APP_IMG_BASE_URL + "/img/" + info?.header_logo} />
                </Link>
              </div>
              <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobilemenu" aria-controls="staticBackdrop">
                <span className="navbar-toggler-icon"></span>
              </button>
             


            </div>



            <div className="collapse navbar-collapse" id="bizcoxx_main_menu">

              <ul className="navbar-nav">
                {
                  menu.map((item, ind) => {
                    if (item?.childran?.length > 0) {
                      return (<li key={ind} className='menu-item-has-children'>
                        <ul className="sub-menu">{item?.childran?.map((subItem, i) => (<li key={i}><NavLink to={`/${subItem.url}`}>{subItem.name}</NavLink></li>))}</ul>
                      </li>)
                    } else {
                      return (<li key={ind}><NavLink to={`/${item.url}`} >{item.name}</NavLink></li>)
                    }
                  })
                }
              </ul>
            </div>
            <div className="nav-right-content">
              <ul>
                <li>
                  <Link to="/donate">
                    <div className="info-bar-item">
                      <div className="icon">
                        <i className="far fa-heart"></i>
                      </div>
                      <div className="content">
                        <span className="title">
                          SUPPORT
                        </span>
                        <p className="details">  DONATE</p>
                      </div>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
    <Outlet />
    <footer className="footer-area">
      <div className="footer-top bg-black bg-image padding-top-85 padding-bottom-50" style={{ backgroundImage: "url(/main/files/static/footer-bg.png)" }}>
        <div className="container">
          <div className="footer-top-border">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="footer-widget widget">
                  <div className="about_us_widget">
                    <Link to="" className="footer-logo"> <img src={process.env.REACT_APP_IMG_BASE_URL + '/img/' + info?.footer_logo} alt="footer logo" /></Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6">
                <div className="footer-widget widget widget_subscribe">
                  <h4 className="widget-title">Subscribe Newsletter</h4>
                  <form className="subscribe-form d-flex" onSubmit={handleSubscribe}>
                    <div className="form-group">
                      <input type="email" className="form-control" placeholder="Your email address" value={data?.email} id="subscribe" onChange={(event) => setData(prev => ({ ...prev, email: event.target.value }))} required />
                    </div>
                    <button type="submit" className="submit-btn subscribe-btn"><i class="bi bi-send"></i></button>
                  </form>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="footer-widget widget">
                  <ul className="contact_info_list">
                    <li className="single-info-item-02">
                      <div className="icon">

                      </div>
                      <div className="details">
                        {info?.phone}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="footer-widget widget ">
                <h4 className="widget-title">About Me</h4>
                <div className="Container" dangerouslySetInnerHTML={{ __html: info?.small_about }}></div>
              </div>
            </div>
            <div className="col-lg-2 offset-lg-1 col-md-6 col-sm-6">
              <div className="footer-widget widget widget_nav_menu">
                <h4 className="widget-title">Quick Link</h4>
                <ul>
                  <li><NavLink to="about-us">About Us</NavLink></li>
                  <li><NavLink to="about-us" data-bs-toggle="modal" data-bs-target="#volunteerLogin">Volunteer Login</NavLink></li>

                  <li><NavLink to="trustee">Trustee</NavLink></li>
                  <li><NavLink to="donation">Donation</NavLink></li>

                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="footer-widget widget widget_nav_menu">
                <h4 className="widget-title">OUR WORK</h4>
                <ul>
                  <li><NavLink to="volunteer/">Become a Volunteer</NavLink></li>
                  <li><NavLink to="terms-and-conditions">Terms & Conditions</NavLink></li>
                  <li><NavLink to="privacy-policy">Privacy & Policy</NavLink></li>
                  <li><NavLink to="refund-cancellation">Refund & Cancellation</NavLink></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <ul className="contact_info_list">
                <li className="single-info-item">
                  <div className="title">
                    Our Address
                  </div>
                  <div className="details d-flex">
                    <div className="Container" dangerouslySetInnerHTML={{ __html: info?.address }}></div>
                  </div>
                </li>
                <li className="single-info-item">
                  <div className="title">
                    Contact us
                  </div>
                  <div className="details">
                    <Link to={'tel:' + info?.phone} className='details'>{info?.phone}</Link>
                    <br />
                    <Link to={'tel:' + info?.email} className='details'>{info?.email}</Link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="copyright-area-inner">
                <div className="Container" dangerouslySetInnerHTML={{ __html: info?.copyright }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="back-to-top">
        <span className="back-top"><i className="fa fa-angle-up"></i></span>
      </div>
    </footer>


    <div class="modal fade" id="volunteerLogin" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" >
      <div class="modal-dialog">
        {
          act?.step ?
            <form class="modal-content" onSubmit={verifyOTP}>
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">Verify</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={close}></button>
              </div>
              <div class="modal-body">
                <div class="form-floating">
                  <input type="text" class="form-control" id="otp" value={data?.otp} onChange={e => setData((prev) => ({ ...prev, otp: e.target.value }))} required />
                  <label htmlFor="otp">OTP</label>
                </div>
                <label> If not received, resend <Link to="#" onClick={sendOTP}>Resend</Link></label>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                {act.verifyOTP ? <button type="button" class="btn btn-primary" disabled><div class="spinner-border" role="status" style={{ width: '15px', height: '15px' }}></div></button> : <button type="submit" class="btn btn-primary">Verify</button>}
              </div>
            </form>
            :
            <form class="modal-content" onSubmit={sendOTP}>
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">Volunteer Login</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={close}></button>
              </div>
              <div class="modal-body">
                <div class="form-floating">
                  <input type="text" class="form-control" id="userid" value={data?.userId} onChange={e => setData((prev) => ({ ...prev, userId: e.target.value }))} required />
                  <label htmlFor="userid">Phone/Email address</label>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                {act?.OTPloader ? <button type="button" class="btn btn-primary" disabled><div class="spinner-border" role="status" style={{ width: '15px', height: '15px' }}></div></button> : <button type="submit" class="btn btn-primary">Send OTP</button>}
              </div>
            </form>
        }
      </div>
    </div>

<div class="offcanvas offcanvas-start" data-bs-backdrop="static" tabindex="-1" id="mobilemenu" aria-labelledby="staticBackdropLabel">
  <div class="offcanvas-header bg-light">
    <Link to="/" className="logo">
                  <img src={process.env.REACT_APP_IMG_BASE_URL + "/img/" + info?.header_logo} />
                </Link>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <div>
     <ul className="navbar-nav">
                {
                  menu.map((item, ind) => {
                    if (item?.childran?.length > 0) {
                      return (<li key={ind} className='menu-item-has-children'>
                        <ul className="sub-menu">{item?.childran?.map((subItem, i) => (<li key={i}><NavLink to={`/${subItem.url}`}>{subItem.name}</NavLink></li>))}</ul>
                      </li>)
                    } else {
                      return (<li key={ind} className='mobmenu' data-bs-dismiss="offcanvas"><NavLink to={`/${item.url}`} >{item.name} <i class="fa fa-chevron-right"></i></NavLink></li>)
                    }
                  })
                }
              </ul>
    </div>
  </div>
</div>

  </>);
}

export default Header;